export const programsData = {
  hero:32,
  extreme:34,
  mommy:33,
  family:35,
  count: 4
}

export const citiesUnipro = [
  {
    label: 'Москва', value: 'Москва'
  },
  {
    label: 'Сургут', value: 'Сургут'
  },
  {
    label: 'Шарыпово', value: 'Шарыпово'
  },
  {
    label: 'Шатура', value: 'Шатура'
  },
  {
    label: 'Смоленск', value: 'Смоленск'
  },
  {
    label: 'Яйва', value: 'Яйва'
  }
  ]
const citiesArr = [
  {
    label: 'Санкт-Петербург', value: 'Санкт-Петербург'
  },
  {
    label: 'Архангельск', value: 'Архангельск'
  },
  {
    label: 'Великий Новгород', value: 'Великий Новгород'
  },
  {
    label: 'Вологда', value: 'Вологда'
  },
  {
    label: 'Калининград', value: 'Калининград'
  },
  {
    label: 'Мурманск', value: 'Мурманск'
  },
  {
    label: 'Нарьян-Мар (Ненецкий АО)', value: 'Нарьян-Мар (Ненецкий АО)'
  },
  {
    label: 'Петрозаводск (Карелия)', value: 'Петрозаводск (Карелия)'
  },
  {
    label: 'Псков', value: 'Псков'
  },
  {
    label: 'Тула', value: 'Тула'
  },
  {
    label: 'Владимир', value: 'Владимир'
  },
  {
    label: 'Калуга', value: 'Калуга'
  },
  {
    label: 'Кострома', value: 'Кострома'
  },
  {
    label: 'Рязань', value: 'Рязань'
  },
  {
    label: 'Смоленск', value: 'Смоленск'
  },
  {
    label: 'Тверь', value: 'Тверь'
  },
  {
    label: 'Воронеж', value: 'Воронеж'
  },
  {
    label: 'Белгород', value: 'Белгород'
  },
  {
    label: 'Брянск', value: 'Брянск'
  },
  {
    label: 'Курск', value: 'Курск'
  },
  {
    label: 'Липецк', value: 'Липецк'
  },
  {
    label: 'Орёл', value: 'Орёл'
  },
  {
    label: 'Пенза', value: 'Пенза'
  },

  {
    label: 'Саранск (Мордовия)', value: 'Саранск (Мордовия)'
  },
  {
    label: 'Саратов', value: 'Саратов'
  },
  {
    label: 'Тамбов', value: 'Тамбов'
  },
  {
    label: 'Ростов-на-Дону', value: 'Ростов-на-Дону'
  },
  {
    label: 'Волгоград', value: 'Волгоград'
  },
  {
    label: 'Краснодар', value: 'Краснодар'
  },
  {
    label: 'Майкоп (Адыгея)', value: 'Майкоп (Адыгея)'
  },
  {
    label: 'Москва', value: 'Москва'
  },
  {
    label: 'Нижний Новгород', value: 'Нижний Новгород'
  },
  {
    label: 'Ижевск (Удмуртия)', value: 'Ижевск (Удмуртия)'
  },

  {
    label: 'Йошкар-Ола (Марий Эл)', value: 'Йошкар-Ола (Марий Эл)'
  },
  {
    label: 'Казань (Татарстан)', value: 'Казань (Татарстан)'
  },
  {
    label: 'Киров', value: 'Киров'
  },
  {
    label: 'Самара', value: 'Самара'
  },
  {
    label: 'Ульяновск', value: 'Ульяновск'
  },
  {
    label: 'Чебоксары (Чувашия)', value: 'Чебоксары (Чувашия)'
  },

  {
    label: 'Екатеринбург', value: 'Екатеринбург'
  },
  {
    label: 'Курган', value: 'Курган'
  },
  {
    label: 'Оренбург', value: 'Оренбург'
  },
  {
    label: 'Пермь', value: 'Пермь'
  },
  {
    label: 'Салехард (ЯНАО)', value: 'Салехард (ЯНАО)'
  },
  {
    label: 'Сыктывкар (Коми)', value: 'Сыктывкар (Коми)'
  },

  {
    label: 'Тюмень', value: 'Тюмень'
  },
  {
    label: 'Ханты-Мансийск', value: 'Ханты-Мансийск'
  },
  {
    label: 'Челябинск', value: 'Челябинск'
  },
  {
    label: 'Новосибирск', value: 'Новосибирск'
  },
  {
    label: 'Абакан (Хакасия)', value: 'Абакан (Хакасия)'
  },

  {
    label: 'Барнаул (Алтайский кр.)', value: 'Барнаул (Алтайский кр.)'
  },
  {
    label: 'Кемерово', value: 'Кемерово'
  },
  {
    label: 'Красноярск', value: 'Красноярск'
  },
  {
    label: 'Кызыл (Тыва)', value: 'Кызыл (Тыва)'
  },
  {
    label: 'Омск', value: 'Омск'
  },

  {
    label: 'Томск', value: 'Томск'
  },
  {
    label: 'Иркутск', value: 'Иркутск'
  },
  {
    label: 'Биробиджан (Еврейская АО)', value: 'Биробиджан (Еврейская АО)'
  },
  {
    label: 'Владивосток', value: 'Владивосток'
  },
  {
    label: 'Магадан', value: 'Магадан'
  },
  {
    label: 'Петропавловск-Камчатский', value: 'Петропавловск-Камчатский'
  },
  {
    label: 'Улан-Удэ (Бурятия)', value: 'Улан-Удэ (Бурятия)'
  },
  {
    label: 'Южно-Сахалинск', value: 'Южно-Сахалинск'
  },
]

export const cities = citiesArr.sort((a,b) =>{
  return a.label < b.label ? -1 : a.label > b.label ? 1 : 0
});

function range(start, count) {
  return Array.apply(0, Array(count))
    .map(function (element, index) {
      return index + start;
    });
}
export const dataHeight= range(140, 81)




// WEBPACK FOOTER //
// /var/www/build-health-2/src/utils/data.js